import { FormControl, InputLabel, Select, MenuItem, FormHelperText, ListItemText } from '@mui/material';
import type { SelectProps } from '@mui/material';
import { ReactNode } from 'react';

import { ArrayElement } from '../../../../../types/general';

export type SelectFormOption<Value> = {
  name?: ReactNode;
  value: Value;
};

export type SelectFormProps<Value> = SelectProps<Value> & {
  label: string;
  placeholder?: string;
  helperText?: string;
  displayType?: 'default' | 'name-small-value' | 'value-small-name' | 'name-small-value-if-name';
  options: readonly SelectFormOption<Value>[];
};

export const SelectForm = <Value extends string | number>(props: SelectFormProps<Value>) => {
  const { label, placeholder, helperText, options, displayType, ...selectProps } = props;

  const renderItem = (item: ArrayElement<typeof options>, index: number) => {
    switch (displayType) {
      case 'name-small-value-if-name':
        return (
          <MenuItem value={item.value} key={index}>
            <div>
              <ListItemText primary={item.name ?? item.value} />
              {item.name && <ListItemText secondary={item.value} />}
            </div>
          </MenuItem>
        );
      case 'name-small-value':
        return (
          <MenuItem value={item.value} key={index}>
            <div>
              <ListItemText primary={item.name ?? item.value} />
              <ListItemText secondary={item.value} />
            </div>
          </MenuItem>
        );
      case 'value-small-name':
        return (
          <MenuItem value={item.value} key={index}>
            <div>
              <ListItemText primary={item.value} />
              <ListItemText secondary={item.name ?? item.value} />
            </div>
          </MenuItem>
        );
      default:
        return (
          <MenuItem value={item.value} key={index}>
            {item.name ?? item.value}
          </MenuItem>
        );
    }
  };

  return (
    <FormControl sx={{ width: '100%' }}>
      <InputLabel>{label}</InputLabel>

      <Select
        slotProps={{
          input: {
            placeholder,
          },
        }}
        {...selectProps}
      >
        {options.map(renderItem)}
      </Select>

      <FormHelperText error={selectProps.error}>{helperText}</FormHelperText>
    </FormControl>
  );
};
